import { DateRangePicker, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate, getLocalTimeZone, today } from "@internationalized/date";

/**
 * Filter component for Single Stock History page
 * Backend: stocks/history/{warehouseId}/{materialId}
 * Filters: date_from, date_to, activity_source
 */
const FilterHistory = ({ table, initialFilters }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    // Handle clear
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    // Derive dateRange from pending
    const dateRange =
        pending.date_from && pending.date_to
            ? {
                  start: parseDate(pending.date_from),
                  end: parseDate(pending.date_to),
              }
            : null;

    // Handle date range change
    const handleDateRangeChange = (range) => {
        if (range) {
            setPending((prev) => ({
                ...prev,
                date_from: range.start.toString(),
                date_to: range.end.toString(),
            }));
        } else {
            setPending((prev) => ({
                ...prev,
                date_from: "",
                date_to: "",
            }));
        }
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Rentang Tanggal */}
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRange}
                onChange={handleDateRangeChange}
                maxValue={today(getLocalTimeZone())}
                variant="flat"
            />

            {/* Sumber Aktivitas */}
            <Select
                label="Sumber Aktivitas"
                placeholder="Semua sumber"
                selectedKeys={
                    pending.activity_source
                        ? new Set([pending.activity_source])
                        : new Set()
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        activity_source: Array.from(keys)[0] || "",
                    }))
                }
                variant="flat"
            >
                <SelectItem key="initial_stock">Stok Awal</SelectItem>
                <SelectItem key="stock_out">Stok Keluar</SelectItem>
                <SelectItem key="purchase">Pembelian</SelectItem>
                <SelectItem key="sales">Penjualan</SelectItem>
                <SelectItem key="adjustment">Penyesuaian</SelectItem>
                <SelectItem key="transfer">Transfer</SelectItem>
            </Select>
        </FilterCard>
    );
};

export default FilterHistory;
